enum ReturnValueDisplayMode {
  ValueOnly,
  PercentageOnly,
  ValueAndPercentage,
}

export default ReturnValueDisplayMode;
